import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'csi-toggleable-medical-history-text-field',
  templateUrl: './toggleable-medical-history-text-field.component.html',
  styleUrls: ['./toggleable-medical-history-text-field.component.css']
})
export class ToggleableMedicalHistoryTextFieldComponent implements OnDestroy {
  private _control: FormControl;
  @Input() set control(control: FormControl) {
    this._control = control;

    // statusChanges/valueChanges are plain streams — they don't replay the control's
    // current value to a new subscriber, so a control that already holds a saved value
    // (e.g. on page load) would otherwise never get its toggle/text state initialized.
    if (control.disabled) {
      this.isViewOnly = true;
      this.hideTextField = false;
    } else {
      this.isViewOnly = false;
      this.setToggleValueBasedOnControlValue();
    }

    control.statusChanges.pipe(untilDestroyed(this)).subscribe(s => {
      if (control.disabled) {
        this.isViewOnly = true;
        this.hideTextField = false;
      } else {
        this.isViewOnly = false;
        this.setToggleValueBasedOnControlValue();
      }
    });

    control.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      if (!control.disabled) {
        this.setToggleValueBasedOnControlValue();
        this.changeRef.markForCheck();
      }
    });
  }
  get control(): FormControl {
    return this._control;
  }

  @Input() label: string;

  public isViewOnly = false;
  public hideTextField = true;

  private _toggleValue: boolean;
  set toggleValue(value: boolean) {
    this._toggleValue = value;
    this.hideTextField = !value;
  }
  get toggleValue(): boolean {
    return this._toggleValue;
  }

  constructor(private changeRef: ChangeDetectorRef) {}

  private setToggleValueBasedOnControlValue() {
    if (this.control.value === 'none') {
      this.toggleValue = false;
    } else if (this.control.value) {
      this.toggleValue = true;
    } else if (this.toggleValue === undefined) {
      this.hideTextField = true;
    }
  }

  public onToggle(val: boolean) {
    this.toggleValue = val;
    if (val === false) {
      this.control.setValue('none');
    } else {
      this.control.setValue(null);
    }
  }

  ngOnDestroy() {}
}
